module.exports = __webpack_public_path__ + "img/info_sp_20.dff75ac1.png";